<script setup lang="ts">
/**
 * TheHeader - верхняя панель для авторизованного пользователя.
 * Содержит: хлебные крошки, переключатель языка, кнопка меню на мобильных.
 */
import { useI18n } from 'vue-i18n'
import LanguageSwitcher from '@/components/shared/LanguageSwitcher.vue'

defineEmits<{ toggleSidebar: [] }>()

const { t } = useI18n()

// Breadcrumbs строятся из route meta
defineProps<{
  title?: string
}>()
</script>

<template>
  <header class="flex items-center h-14 px-4 border-b border-primary/5 bg-base-100/80 backdrop-blur-sm sticky top-0 z-40">
    <!-- Мобильная кнопка меню -->
    <button
      class="btn btn-ghost btn-sm btn-square lg:hidden mr-2"
      @click="$emit('toggleSidebar')"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-5 h-5"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
        />
      </svg>
    </button>

    <!-- Заголовок текущей страницы -->
    <div class="flex-1">
      <h2
        v-if="title"
        class="text-sm font-medium text-base-content/70"
      >
        {{ t(title) }}
      </h2>
    </div>

    <!-- Правая часть -->
    <div class="flex items-center gap-2">
      <LanguageSwitcher />
    </div>
  </header>
</template>
